import React from "react";

export default function Hexagon1() {
  return (
    <svg viewBox="0 0 269.5 283" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m7077.6 7127.4-12.6 96.4a28.8 28.8 0 0 0 13.1 28.1l132.6 84.4a28.9 28.9 0 0 0 34.8-2.8l61.6-55.5a28.2 28.2 0 0 0 9.1-15.9l17.5-89.4a28.7 28.7 0 0 0 -7.5-25.4l-76.6-80.5a29 29 0 0 0 -30.7-7.2l-122.5 44.4a28.8 28.8 0 0 0 -18.8 23.4"
        fill="#00a88e"
        transform="translate(-7064.7 -7057.9)"
      />
    </svg>
  );
}
